<!-- 针对小花的老客福利活动 -->
<template>
  <div class="page-container">
    <navigation
      :theme="{
        background:'#FF6925',
        color:'#fff',
      }"
      arrTheme='white'
    >
      <span>专享福利</span>
      <span
        slot="right"
        class="rule-txt"
        @click="jumpRule"
        data-sensors-click
      >活动规则</span>
    </navigation>
    <div class="main-container">
      <div class="header"><img src="./images/img_title@2x.png"></div>
      <i class="animate"></i>
      <div class="bonus"><img
        src="./images/img_card@2x.png"
        width="100%"
      ></div>
      <div class="btn btn-1" @click="handleUse" data-sensors-click><img
        src="./images/btn_tixian@2x.png"
        width="100%"
      ></div>
      <div class="get-bonus" v-if="detail.showActive === 'Y'">
        <div class="title">
          <span @click="$router.push('/quan/list')">查看券包 ></span>
        </div>
        <div class="bonus-info">
          <div class="user-info">
            <img src="./images/img_head@2x.png">
            <span>{{ phone }}</span>
          </div>
          <div class="coupon1 coupon-container"  v-if="detail.showRaiseAmt === 'Y'">
            <span class="corner-marker">提额福利</span>
            <div class="flex">
              <div class="inner-info">
                <div class="inner-title">专属提额券</div>
                <p class="amt">{{detail.raiseAmt}}元</p>
                <p class="tips">仅限天美贷自营平台使用</p>
              </div>
              <div class="inner-btn btn-limit" @click="handleUse" data-sensors-click>
                去使用
              </div>
            </div>
          </div>
          <div class="coupon1 coupon-container" :class="{disabled:!interestFreeStatus}">
            <span class="corner-marker">免息福利</span>
            <div class="flex">
              <div class="inner-info">
                <div class="inner-title">专属免息券</div>
                <p class="amt">{{detail.intDay || 15}}天</p>
              </div>
              <div class="inner-btn btn-free" data-sensors-click @click="handleUse('free')">
                {{ btnText }}
              </div>
            </div>
            <p class="mt10">领取进度：{{progress}}%</p>
            <div class="ui-bar"><i :style="`width:${progress}%`"></i></div>
            <div class="step-container">
              <div class="item">  <span>0%</span> <p>登录天美贷</p> </div>
              <div class="item">  <span>33%</span> <p>提现1/3笔</p> </div>
              <div class="item">  <span>66%</span> <p>提现2/3笔</p> </div>
              <div class="item">  <span>100%</span> <p>提现3/3笔</p> </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else style="height: 1.8rem;"></div>

      <p class="active-tips">活动说明：福利仅限天美贷自营平台使用（天美贷APP、天美贷微信公众号、天美贷极速借小程序）</p>
      <img
        src="./images/img_laoke@2x.png"
        class="watermark"
      >
    </div>

  </div>
</template>

<script>
import { getKey } from '@/assets/utils'
import { mapActions } from 'vuex'

export default {
  data () {
    return {
      countDownTime: 0,
      detail: {
        withdrawCount: 0, // 提现次数 
        interestFreeStatus: '', // 免息优惠券状态,TO_CLAIM:去领取,TO_USE:去使用,USED:已使用,EXPIRED:已失效
        couponNo: '' // 优惠券编号
        
      }
    }
  },
  async mounted () {
    await this.getUserInfoX({ forceUpdate: true })
    this.detailRoseWallet()
    this.$bus.$emit('ready')
  },
  computed: {
    interestFreeStatus () {
      return ['TO_CLAIM', 'TO_USE'].includes(this.detail.interestFreeStatus) 
    },
    btnText () {
      const text = {
        TO_CLAIM: '去领取',
        TO_USE: '去使用',
        USED: '已使用',
        EXPIRED: '已过期'
      }
      return text[this.detail.interestFreeStatus] || '去领取'
    },
    progress () {
      const _p = {
        0: 10,
        1: 33,
        2: 66,
        3: 100
      }
      return _p[this.detail.withdrawCount] || 10
    },
    phone () {
      const userinfo = getKey('userInfo')
      return userinfo.mobile
        ? userinfo.mobile.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
        : ''
    }
  },
  methods: {
    ...mapActions('activities', ['detailRoseWalletX']),
    ...mapActions('user', ['getUserInfoX']),
    handleUse (type) {
      if (this.detail.showActive === 'N') {
        this.$message('请前往天美贷APP或公众号登录领取福利', 5000)
        return
      }
      if (type === 'free' && !this.interestFreeStatus) {
        return
      }
      this.$router.push({
        path: '/middle/coupon',
        query: {
          skipType: 'TMD_WITHDRAW',
          cacheCouponSerialNo: 'Y',
          couponSerialNo: type === 'free' ? this.detail.couponNo : ''
        }
      })
    },
    async detailRoseWallet () {
      const { success, data } = await this.detailRoseWalletX({
        activeCode: 'ACTIVE_BOX'
      })
      if (success) {
        this.detail = data || {}
      }
    },
    jumpRule () {
      this.$router.push('/actvie/oldCustomerBonus/rule')
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

.page-container {
  background: #ffe7cb;

  min-height: 100vh;
  .main-container {
    background: url("./images/bg.png") no-repeat;
    background-size: 100% 1300px;
    min-height: 1300px;
    margin-top: -2px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .header {
      width: 600px;
      img {
        width: 100%;
        margin-top: 32px;
      }
    }
    @keyframes tt {
      0% {
        transform: translateY(0);
      }
      100% {
        transform: translateY(10px);
      }
    }
    .animate {
      width: 620px;
      height: 250px;
      display: block;
      background: url(./images/img_jinbi@2x.png) no-repeat;
      background-size: 100% 100%;
      animation: tt 0.5s infinite alternate;
    }
    .bonus {
      width: 592px;
      margin-top: 153px;
    }
    @keyframes ss {
      to {
        transform: scale(1.1);
      }
    }
    .btn {
      width: 620px;
      margin-top: 30px;
      animation: ss 0.5s infinite alternate;
    }
  }

  .get-bonus {
    width: 690px;
    padding-top: 10px;
    .title {
      background: url(./images/img_lingqufuyli@2x.png) no-repeat;
      background-size: 100% 100%;
      height: 130px;
      display: flex;
      flex-flow: row-reverse;
      align-items: center;
      padding-right: 30px;
      span {
        font-size: 28px;
        color: #fff;
        font-family: PingFangSC, PingFang SC;
      }
    }
    .bonus-info {
      background: #fff;
      padding: 30px;
      border-radius: 30px;
      margin-top: -20px;
    }
    .user-info {
      display: flex;
      align-items: center;
      gap: 12px;
      margin-bottom: 30px;
      span {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 30px;
        color: #333333;
      }
      img {
        width: 80px;
        height: 80px;
      }
    }

    .coupon-container {
      width: 630px;
      background: #ffeaea;
      border-radius: 20px;
      position: relative;
      margin-bottom: 10px;
      padding: 54px 30px 30px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 22px;
      color: #996767;
      &.disabled {
        filter: grayscale(1);
        opacity: 0.7;
      }
      .flex {
        display: flex;
        justify-content: space-between;
      }
      .inner-btn {
        width: 200px;
        height: 64px;
        line-height: 64px;
        text-align: center;
        background: url(./images/btn_shiyong@2x.png) no-repeat;
        background-size: 100% 100%;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 32px;
        color: #ffffff;
      }
      .corner-marker {
        position: absolute;
        width: 120px;
        height: 40px;
        line-height: 40px;
        background: linear-gradient(90deg, #f58635 0%, #ff3333 100%);
        border-radius: 20px 0px 20px 0px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 22px;
        color: #ffffff;
        text-align: center;
        left: 0;
        top: 0;
      }

      .inner-title {
        font-family: PingFangSC, PingFang SC;
        font-weight: bold;
        font-size: 32px;
        color: #690a0a;
        line-height: 45px;
      }
      .amt {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 32px;
        color: #d40f0f;
      }
      .mt10 {
        margin-top: 10px;
      }
      .ui-bar {
        width: 570px;
        height: 20px;
        background: #E5C9C9;
        border-radius: 10px;
        margin:12px 0;
        i {
          display: block;
          height: 100%;
          background: linear-gradient( 90deg, #F58635 0%, #FF3333 100%);
          border-radius: 10px;
        }
      }
      .step-container {
        display: flex;
        margin: 0 -15px;
        justify-content: space-between;
        .item {
          text-align: center;
        }
      }
    }
  }
  .active-tips {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 22px;
    color: #874919;
    line-height: 30px;
    padding: 30px;
  }
  .watermark {
    width: 300.97px;
    margin-bottom: 60px;
  }
  .rule-txt {
    font-family: PingFangSC, PingFang SC;
    font-size: 28px;
    color: #ffffff;
    line-height: 40px;
    text-align: right;
    font-style: normal;
    margin-right: 40px;
    display: block;
  }
}
</style>